
import { FeedbackStep, useFeedbackStore } from '@pages/feedback'

import { defineNuxtRouteMiddleware } from '#app'

const VALID_STEPS = Object.values(FeedbackStep) as string[]

export default defineNuxtRouteMiddleware((to) => {
  const feedbackStore = useFeedbackStore()

  const queryStep = to?.query?.step as string | undefined

  if (queryStep && VALID_STEPS.includes(queryStep)) {
    feedbackStore.setStep(queryStep as FeedbackStep)
  } else {
    const currentStep = feedbackStore.getStep
    const stepOrder = feedbackStore.getStepOrder
    const restoredStep = stepOrder.includes(currentStep) ? currentStep : stepOrder[0]!

    feedbackStore.setStep(restoredStep)
  }
})
